import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;          // "order_customer", "product", "department", "sales_customer"
  doc_type?: string;             // "sample", "bulk", "all", "inventory"
  date_from?: string;            // YYYY-MM-DD
  date_to?: string;              // YYYY-MM-DD
  sales_customer_from?: string;
  sales_customer_to?: string;
  order_customer_from?: string;
  order_customer_to?: string;
  product_from?: string;
  product_to?: string;
  dept_from?: string;
  dept_to?: string;
  delivery_no_from?: string;
  delivery_no_to?: string;
}

export interface CustomerStatRow {
  customer_code: string;
  customer_name: string;
  currency: string;
  delivery_count: number;
  total_amt: number;
  total_nt_amt: number;
}

export interface ProductStatRow {
  product_code: string;
  product_desc: string;
  unit: string;
  currency: string;
  total_qty: number;
  total_amt: number;
  total_nt_amt: number;
}

export interface DeptStatRow {
  dept_code: string;
  dept_name: string;
  customer_code: string;
  currency: string;
  total_amt: number;
  total_nt_amt: number;
}

export interface SalesCustomerStatRow {
  sales_customer_code: string;
  sales_customer_name: string;
  order_customer_code: string;
  currency: string;
  delivery_count: number;
  total_amt: number;
  total_nt_amt: number;
}

export interface CurrencySummary {
  currency: string;
  total_amt: number;
  total_nt_amt: number;
}

export interface UnitSummary {
  unit: string;
  currency: string;
  total_qty: number;
  total_amt: number;
  total_nt_amt: number;
}

export interface CustomerQueryResponse {
  report_type: string;
  data: CustomerStatRow[];
  count: number;
  currency_summary: CurrencySummary[];
  message?: string;
}

export interface ProductQueryResponse {
  report_type: string;
  data: ProductStatRow[];
  count: number;
  unit_summary: UnitSummary[];
  message?: string;
}

export interface DeptQueryResponse {
  report_type: string;
  data: DeptStatRow[];
  count: number;
  currency_summary: CurrencySummary[];
  message?: string;
}

export interface SalesCustomerQueryResponse {
  report_type: string;
  data: SalesCustomerStatRow[];
  count: number;
  currency_summary: CurrencySummary[];
  message?: string;
}

export type QueryResponse = CustomerQueryResponse | ProductQueryResponse | DeptQueryResponse | SalesCustomerQueryResponse;

export const c305Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c305/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/c305/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
